import {
  formatEther,
  parseEther,
  readContract,
  writeContractAndWait,
  zeroAddress,
} from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaPlayerSubscriptionAbi from "../../abis/MafiaPlayerSubscription.json";
import config from "../../config/config";
import { delay } from "../../utils/utils";
import { isIndexingTxError } from "../parseTxError";

const address = config.playerSubscription;
const abi = MafiaPlayerSubscriptionAbi;

export const subscribe = async (
  swapTokenId: number,
  tokenAddress: string,
  tokenAmount: number,
  planType: number,
  account: string
) => {
  if (tokenAddress === zeroAddress) {
    const nativeAmount = parseEther(tokenAmount.toFixed(18));
    const subscribe = await writeContractAndWait({
      address,
      abi,
      functionName: "subscribe",
      args: [swapTokenId, planType],
      account,
      value: nativeAmount,
    });
    return subscribe;
  } else {
    const tokenAllowance = await getTokenAllowance(
      tokenAddress,
      account,
      config.playerSubscription
    );

    try {
      if (Number(tokenAllowance) < tokenAmount) {
        await approveToken(
          tokenAddress,
          tokenAmount,
          config.playerSubscription,
          account
        );

        await delay(config.blockTime);
      }
    } catch (error: any) {
      if (isIndexingTxError(error)) {
        await delay(config.blockTime);
      } else {
        throw error;
      }
    }

    const subscribe = await writeContractAndWait({
      address,
      abi,
      functionName: "subscribe",
      args: [swapTokenId, planType],
      account,
    });
    return subscribe;
  }
};

export const isSubscribed = async (user: string) => {
  const isSubscribed: boolean = await readContract({
    address,
    abi,
    functionName: "isSubscribed",
    args: [user],
  });
  return isSubscribed;
};

export const isUnlimitedUser = async (user: string) => {
  const isUnlimitedUser: boolean = await readContract({
    address,
    abi,
    functionName: "isUnlimitedUser",
    args: [user],
  });
  return isUnlimitedUser;
};

export const getSubscriptionInfo = async (user: string) => {
  const subscriptionInfo = await readContract({
    address,
    abi,
    functionName: "getSubscriptionInfo",
    args: [user],
  });
  return subscriptionInfo;
};

export const getPlanPrice = async () => {
  const plusPlanPrice: number = await readContract({
    address,
    abi,
    functionName: "planPrice",
    args: [1],
  });

  const unlimitedPlanPrice: number = await readContract({
    address,
    abi,
    functionName: "planPrice",
    args: [2],
  });

  return {
    plusPlanPrice: Number(formatEther(plusPlanPrice)),
    unlimitedPlanPrice: Number(formatEther(unlimitedPlanPrice)),
  };
};

export const activateSubscriptionItem = async (
  account: string,
  itemId: number
) => {
  const activateSubscriptionItem = await writeContractAndWait({
    address,
    abi,
    functionName: "activateSubscriptionItem",
    args: [itemId],
    account,
  });

  return activateSubscriptionItem;
};
